import React from 'react';
import Button from '../components/button.js';
import Logo from '../images/jcoyne-logo-medium.png';
import LogoHTML from '../images/html-logo.png';
import LogoCSS from '../images/css-logo.png';
import LogoJS from '../images/js-logo.png';

export default function About() {

    return (
        <div id="about">
            <h2>Learn More About Me</h2>
            <div className="resume" id="professionalskills">
                <h3>My Professional Skills</h3>
                <ul>
                    <li>Mastery over the basics of Web Development: HTML, CSS, and JavaScript.</li>
                    <li>Knowledge and significant experience with various JavaScript libraries and environments including but not limited to React, Node.js, and NextJS.</li>
                    <li>Knowledge and experience in other coding languages such as PHP, MySQL, Python, and Kotlin.</li>
                    <li>Experience with Adobe products including Photoshop, Illustrator, and Indesign.</li>
                    <li>Experience with the Microsoft suite of programs (including Word, Excel, Powerpoint, and Outlook) as well as the Google suite of programs (including Google Drive, Google Docs, Google Sheets, and Google Slides).</li>
                    <li>Experience with prompt engineering on the largest commercially available large language models such as ChatGPT and DeepSeek.</li>
                    <li>Experience with OpenAI's APIs and similar tools designed to create specific AI models based off of larger LLMs such as ChatGPT.</li>
                    <li>Extensive experience with scientific research and writing, including significant work as a research assistant in laboratory settings.</li>
                    <li>Extensive teaching experience, including both one-on-one tutoring as well as planning and leading lessons and learning laboratories for intro level college classes.</li>
                </ul>
            </div>
            <div className="resume" id="myhistory">
                <h3>My History</h3>
                <div className="historyentry">
                    <h4>Freelancer: 2020 - 2022, 2023 - Present</h4>
                    <ul>
                        <li>Work with clients to ensure high-quality products that meet their needs and exceed their expectations.</li>
                        <li>Deliver high quality websites, databases, and graphics in a timely fashion.</li>
                        <li>Provide additional services in line with my expertise, including graphic design and technical support.</li>
                    </ul>
                </div>
                <div className="historyentry">
                    <h4>Webmaster, National Addiction Awareness Complex: 2023 - Present</h4>
                    <ul>
                        <li>Spearheaded the redesign of the National Addiction Awareness Center &#40;NAAC&#41; website.</li>
                        <li>Worked with online web builders and created a custom WordPress theme.</li>
                        <li>Maintenence of the site since its launch.</li>
                        <li>Provide timely updates, refurbishments, and additions to specific pages as NAAC's project advances.</li>
                        <li>Provide additional graphic design help and technical support.</li>
                    </ul>
                </div>
                <div className="historyentry">
                    <h4>Internship, Northampton Community College: 2022</h4>
                    <ul>
                        <li>Added additional functionality to a professor's class site.</li>
                        <li>Created mock-ups and prototypes of new functionality options.</li>
                        <li>Worked with online web builders and server hosts.</li>
                        <li>Met with representatives of online web builders in order to propose and brainstorm new functionality.</li>
                    </ul>
                </div>
                <div className="historyentry">
                    <h4>Research Technician, Rodale Institute: 2019 - 2020</h4>
                    <ul>
                        <li>Extensive data collection and analysis.</li>
                        <li>Assisted with, proofreaded, and wrote scientific reports.</li>
                        <li>Assisted with, conducted, and developed plans for experiments.</li>
                    </ul>
                </div>
                <div className="historyentry">
                    <h4>Writer/Editor, Pittsburgh Climate Center: 2018</h4>
                    <ul>
                        <li>Wrote and edited articles intended to educate the general populace.</li>
                        <li>Conducted interviews and curated research.</li>
                        <li>Worked with professionals from a variety of fields.</li>
                    </ul>
                </div>
                <div className="historyentry">
                    <h4>Undergraduate Research Assistant, University of Pittsburgh: 2017 - 2018</h4>
                    <ul>
                        <li>Ran image color analysis on sediment cores.</li>
                        <li>Developed multiple programs to convert RGB colors into L*a*b* colors</li>
                        <li>Worked on a program to color correct the sediment cores.</li>
                    </ul>
                </div>
            </div>
            <div className="resume" id="education">
                <h3>My Education</h3>
                <div className="educationentry">
                    <h4>Northampton Community College, 2021 - 2023</h4>
                    <p>3.9 GPA, obtained an Associate's Degree in Web Development</p>
                </div>
                <div className="educationentry">
                    <h4>University of Pittsburgh, 2014 - 2018</h4>
                    <p>Pursued a Geology degree, maintained a consistent position on the Dean's List, acquired significant research and teaching experience.</p>
                </div>
            </div>
            <div className="resume" id="personalabout">
                <h3>More About Me</h3>
                <p>The above categorizes my accomplishments, and while I'm proud of them, I also want to share more about my life. When I'm not working, I love to hike, bike, and generally explore my surroundings. My favorite place to do these things is World's End State Park, in Sullivan County. My goal in the next decade is to travel more of the world, with New Zealand, the Alps, and China as my “must-see” destinations.</p>
                <p>While I am a professional web developer, I also consider myself an amateur in many categories: cooking, history, and linguistics. My favorite dish to cook is Chicken Corn Soup, which I make with homemade broth and rivels made from scratch, though I am also extremely proud of my tamales.</p>
                <p>My historical passion is the Near East Bronze Age and pre-Columbian Americas, though I will gladly talk your ear off about any interesting historical event, and will gladly be talked to about any outside of my realm of experience.</p>
                <p>My linguistic passion is the creation of conlangs, short for constructed languages, in which a language is artificially created by one person or a small group of creators. Examples in popular culture include the Elvish languages from Lord of the Rings, Dothraki from Game of Thrones, and Esperanto. In terms of natural languages, I'm in the process of learning Mandarin Chinese, though I find all languages fascinating and love learning more about them.</p>
            </div>
        </div>
    )
}